import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { TokensAPI , apiErrorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useToast } from "@/hooks/use-toast";
import { KeyRound, Loader2, Flame } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function RedeemPage() {
  const { user, refreshUsage, setUser } = useAuth();
  const [code, setCode] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const { toast } = useToast();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!user) {
      navigate(`/login?next=${encodeURIComponent("/redeem")}`);
      return;
    }
    setLoading(true);
    try {
      const r = await TokensAPI.redeem(code.trim());
      toast({ title: "Pro unlocked", description: `Active until ${new Date(r.data.pro_expires_at).toLocaleString()}` });
      // Refresh user info
      const meRes = await (await import("@/lib/api")).AuthAPI.me();
      setUser(meRes.data);
      await refreshUsage();
      navigate("/dashboard");
    } catch (err) {
      toast({ title: "Couldn't redeem code", description: apiErrorMessage(err, "Try again"), variant: "destructive" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grain">
      <Navbar />
      <section className="relative min-h-[75vh] py-16">
        <div className="ember-glow absolute inset-0" />
        <div className="relative mx-auto max-w-2xl px-4 sm:px-6">
          <div className="text-center">
            <span className="chip mx-auto"><Flame className="h-3 w-3 text-[#4aa4ff]" /> Redeem Pro</span>
            <h1 className="display-font mt-4 text-4xl font-bold tracking-tight sm:text-5xl">Unlock Pro for <span className="ember-text">30 days</span>.</h1>
            <p className="mt-3 text-muted-foreground">Enter your Pro token code below. Codes are one-use and stackable — redeem multiple to extend your window.</p>
          </div>

          <form onSubmit={submit} className="mt-10 rounded-2xl border border-border bg-card p-8">
            <Label htmlFor="code">Pro token code</Label>
            <div className="relative mt-2">
              <KeyRound className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
              <Input
                id="code"
                value={code}
                onChange={(e) => setCode(e.target.value.toUpperCase())}
                placeholder="FDL-XXXX-XXXX-XXXX-XXXX"
                className="mono h-12 pl-9 uppercase tracking-widest"
                required
              />
            </div>
            <Button type="submit" disabled={loading} className="btn-ember mt-5 h-11 w-full font-semibold">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Redeem code"}
            </Button>
            <p className="mt-4 text-center text-xs text-muted-foreground">Don&apos;t have a code? <a className="text-[#4aa4ff] hover:underline" href="mailto:hello@furnace.design">Contact us</a> or <a className="text-[#4aa4ff] hover:underline" href="/pricing">get Lifetime</a>.</p>
          </form>
        </div>
      </section>
      <Footer />
    </div>
  );
}
